import React, { Component } from "react";
import { connect } from "react-redux";
import Body from "./HTMLRender";
import { Dialog, DialogContent } from "@material-ui/core";
import Answer from "./Answer";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import swal from 'sweetalert';

const editorConfiguration = {
    toolbar: [ 'bold', 'italic', 'hyperlink', '|', 'undo', 'redo', ]
};


class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selected: "",
      submitted: false,
      shortAnswer: "",
      checkpointToDo: true,
      
    };
  }
  //to-do: check if data is already saved for this question in user answers redux and if so, store its value to short answer/selected
  componentDidMount() {
    let question_text;
    if (this.props.activeScene.checkpoints.length !== 0) {
      let question = this.props.activeScene.checkpoints.filter(
        (question) => !question.answer
      );
      question_text = question[0].data;
    }
    this.setState({
      ...this.state,
      question_text: question_text,
    });
  }
  checkAnswer = () => {
      this.setState({
        ...this.state,
        submitted: true,
        checkpointToDo: false,
      });
      
      if (this.state.shortAnswer.length > 0) {
        this.props.dispatch({
          type: "SET_CHECKPOINT_DATA",
          payload: {
            lesson_id: this.props.activeLesson.id,
            question_text: this.props.activeScene.checkpoints[0].data,
            data: this.state.shortAnswer,
            feedback: null,
            scene_number: this.props.activeScene.scene_number
          },
        });
      } else if (this.state.shortAnswer.length === 0){
        this.props.dispatch({
            type: "SET_CHECKPOINT_DATA",
            payload: {
              lesson_id: this.props.activeLesson.id,
              question_text: this.state.question_text,
              data: this.state.selected.data,
              feedback: this.state.selected.alt,
              scene_number: this.props.activeScene.scene_number
            },
          });
      }
  };
  confirmEnd = () => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to end this lesson? All of your data will be erased.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        this.props.dispatch({type: 'SET_ACTIVE_LESSON', payload: {}});
        this.props.dispatch({type: 'OPEN_DECISION'})
        this.props.dispatch({type: "RESET_USER_DECISION_DATA", payload: {"1": {question: '', choice: [] }, "2": {question: '', choice: [] }, "3": {question: '', choice: [] }, "4": {question: '', choice: [] }, "5": {question: '', choice: [] }, "6": {question: '', choice: [] }, "7": {question: '', choice: [] }, "8": {question: '', choice: [] }, "9": {question: '', choice: [] }}});
      } else {
        swal({icon: "success",
            text: "Okay, continue on."});
      }
    });
  }
  getPreviousScene = () => {
    let lessonHistory = this.props.lessonHistory;
    let thisScene = lessonHistory.filter(
      (scene) => scene.current_scene === this.props.activeScene.scene_number
    );
    this.props.dispatch({
      type: "SET_ACTIVE_SCENE",
      payload: this.props.lessonData[thisScene[0].previous_scene],
    });
  };
  handleSubmitFor = (item) => {
 
    this.setState({ ...this.state, selected: item });
    
  };
  handleChangeFor = (event, property) => {

    this.setState({
      ...this.state,
      [property]: event,
    });
  };

  setNextScene = (scene) => {
    this.props.dispatch({
      type: "ADD_TO_HISTORY",
      payload: {
        current_scene: this.props.lessonData[scene].scene_number,
        previous_scene: this.props.activeScene.scene_number,
      },
    });
    this.props.dispatch({
      type: "SET_ACTIVE_SCENE",
      payload: this.props.lessonData[
        this.props.activeScene.navigation[0].available_scene
      ],
    });
    this.setState({
      open: false,
      selected: "",
      submitted: false,
      shortAnswer: "",
      checkpointToDo: true,
    });
    window.scrollTo(0, 0);
  };

  render() {
    
    return (
      <div className="buttons-container space-atop flex-box flex-end">
        {this.props.activeScene.scene_number > 2 && (
          <button className="button" onClick={() => this.getPreviousScene()}>
            &larr;&nbsp;Previous
          </button>
        )}
        {this.props.activeScene.navigation.length === 1 &&
          !this.props.activeScene.checkpoint && !this.props.activeScene.last && (
            <button
              className="button"
              onClick={() =>
                this.setNextScene(
                  this.props.activeScene.navigation[0].available_scene
                )
              }
            >
              Next &rarr;
            </button>
          )}
        {this.props.activeScene.last && (
         <button
              className="button"
              onClick={()=>this.confirmEnd()}
            >
              End lesson
            </button>
          )}
        {this.props.activeScene.checkpoint && this.state.checkpointToDo && (
          <button
            className="button"
            onClick={() => this.setState({ ...this.state, open: true })}
          >
            Reflect and Assess
          </button>
        )}
        {!this.state.checkpointToDo && (
          <div>
            {this.props.activeScene.navigation.map((nav, i) => {
              return (
                <div key={i}>
                  <button
                    className="button"
                    onClick={() => this.setNextScene(nav.available_scene)}
                  >
                    {nav.text}&nbsp;&rarr;
                  </button>
                </div>
              );
            })}
          </div>
        )}
        <Dialog
          className="dialog-pop"
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
        >
          <DialogContent>
            {!this.state.submitted && (
              <div>
                {this.props.activeScene.checkpoints.length > 0 &&
                  this.props.activeScene.checkpoints.map((item, i) => {
                    if (!item.answer) {
                      return (
                        <div className="body-text" key={i}>
                          <div className="flex-box flex-row dialog-question-title">
                            <h4>Checkpoint</h4>
                          </div>
                          <div className="dialog-question">
                            <Body text={item.data}/>
                          </div>
                        </div>
                      );
                    } else {
                      return false;
                    }
                  })}
                {this.props.activeScene.checkpoints.length > 0 &&
                  this.props.activeScene.checkpoints.map((item, i) => {
                    if (item.answer) {
                      return (
                        <div key={i}>
                          {this.state.selected === item ? (
                            <div className="answer-div true">
                              <Answer
                                selected={this.state.selected}
                                handleSubmitFor={this.handleSubmitFor}
                                item={item}
                                tabindex={i + 1}
                              />
                            </div>
                          ) : (
                            <div className="answer-div">
                              <Answer
                                selected={this.state.selected}
                                handleSubmitFor={this.handleSubmitFor}
                                item={item}
                                tabindex={i + 1}
                              />
                            </div>
                          )}
                        </div>
                      );
                    } else {
                      return false;
                    }
                  })}
                {this.props.activeScene.checkpoints.length > 0 &&
                  this.props.activeScene.checkpoints.map((item, i) => {
                    if (!item.answer && item.question_type === 2) {
                      return (
                        <div key={i}>
                          <CKEditor
                            className="full-width"
                            editor={ClassicEditor}
                            config={editorConfiguration}
                            data={this.state.shortAnswer}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              this.handleChangeFor(data, "shortAnswer");
                            }}
                            onBlur={(event, editor) => {
                              console.log("Blur.", editor);
                            }}
                            onFocus={(event, editor) => {
                              console.log("Focus.", editor);
                            }}
                          />
                        </div>
                      );
                    } else {
                      return false;
                    }
                  })}
                <div className="flex-box flex-end">
                  <button className="button" onClick={() => this.checkAnswer()}>
                    Submit
                  </button>
                </div>
              </div>
            )}
            {this.state.submitted && this.state.shortAnswer.length === 0 && (
              <div>
                <div className="flex-box">
                  <h4 className="read-more transparent">
                    Your response: &nbsp;&nbsp;
                    <Body text={this.state.selected.data} />
                  </h4>
                </div>
                <div className="feedback">
                  <Body text={this.state.selected.alt} />
                </div>
                <div className="flex-box flex-end">
                  <button
                    className="button"
                    onClick={() =>
                      this.setState({ ...this.state, open: false })
                    }
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            {this.state.submitted && this.state.shortAnswer.length !== 0 && (
              <div>
                <div className="flex-column">
                  <h4 className="read-more transparent">Your response: </h4>
                  <Body text={this.state.shortAnswer} />
                  <p>You can download your answers at the end of the lesson.</p>
                </div>
                <div className="flex-box flex-end">
                  <button
                    className="button"
                    onClick={() =>
                      this.setState({ ...this.state, open: false })
                    }
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  activeScene: state.activeScene,
  lessonData: state.lessonData,
  lessonHistory: state.lessonHistory,
  activeLesson: state.activeLesson,
  checkpointData: state.checkpointData
});
export default connect(mapStateToProps)(Navigation);
